import React from 'react';
import { Modal, ModalDialog, ModalClose, Typography, Button, Stack, Box } from '@mui/joy';
import { useNavigate } from 'react-router-dom';

interface SessionExpiredModalProps {
  open: boolean;
  onClose: () => void;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleSignIn = () => {
    // Store current path for redirect after login
    const currentPath = window.location.pathname + window.location.search;
    localStorage.setItem('redirectAfterLogin', currentPath);
    
    // Navigate to sign in page
    navigate('/auth/signin');
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        aria-labelledby="session-expired-modal"
        size="sm"
        sx={{
          maxWidth: 400,
          p: 3,
        }}
      >
        <ModalClose />
        <Box sx={{ textAlign: 'center', py: 2 }}>
          <Typography
            component="h2"
            level="h4"
            sx={{ mb: 2, color: 'primary.500' }}
          >
            Session Expired
          </Typography>
          
          <Typography level="body-md" sx={{ mb: 3, color: 'neutral.600' }}>
            Your session has expired. Please sign in again to continue.
          </Typography>
          
          <Stack spacing={2}>
            <Button
              onClick={handleSignIn}
              size="lg"
              sx={{ width: '100%' }}
            >
              Sign In
            </Button>
            
            <Button
              variant="outlined"
              onClick={onClose}
              size="sm"
            >
              Close
            </Button>
          </Stack>
        </Box>
      </ModalDialog>
    </Modal>
  );
};

export default SessionExpiredModal; 